import { InjectionToken } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { InventoryProductDetail } from '../types/inventory-product-detail';
import { SOFTLINE_API_INVENTORY_GET_ITEM_DETAIL } from '../inventory.api';

export interface InventoryProductDetailRepository {
  load(
    productId: number,
    queryParams: {
      idlagerstamm?: number;
      idarteh?: number | undefined;
      idmanartikeldat?: number | undefined;
    }
  ): Promise<InventoryProductDetail>;
}

export const SOFTLINE_MDE_INVENTORY_PRODUCT_DETAIL_REPOSITORY =
  new InjectionToken<InventoryProductDetailRepository>(
    'SOFTLINE_MDE_INVENTORY_PRODUCT_DETAIL_REPOSITORY'
  );

export class DefaultInventoryProductDetailRepository
  implements InventoryProductDetailRepository
{
  constructor(protected dataAccess: ApiDataAccess) {}

  async load(
    productId: number,
    queryParams: {
      idlagerstamm?: number;
      idarteh?: number | undefined;
      idmanartikeldat?: number | undefined;
    }
  ): Promise<InventoryProductDetail> {
    const response = await this.dataAccess.get<ResponseResult<InventoryProductDetail>>({
      path: SOFTLINE_API_INVENTORY_GET_ITEM_DETAIL,
      pathParams: {
        id: productId,
      },
      queryParams,
    });

    return response.result;
  }
}
